import React from 'react';
import format from 'date-fns/format';

export default class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showingGMT: props.showingGMT };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showingGMT !== this.props.showingGMT) {
      this.setState({ showingGMT: nextProps.showingGMT });
    }
  }

  pressGMT() {
    this.setState({ showingGMT: true });
    this.props.onPressButton(true);
  }
  
  pressLocal() {
    this.setState({ showingGMT: false });
    this.props.onPressButton(false);
  }

  toggle() {
    this.setState({ showingGMT: !this.state.showingGMT }, () =>
      this.props.onPressButton(this.state.showingGMT)
    );
  }

  render() {
    return (
      <div className="timezone__button">
        <button
          className={this.state.showingGMT ? 'selected' : ''}
          onClick={this.pressGMT.bind(this)}
        >
          GMT
        </button>
        <span className={this.state.showingGMT ? 'selected' : ''} onClick={this.toggle.bind(this)}>
          <div className="switch" />
        </span>
        <button
          className={!this.state.showingGMT ? 'selected' : ''}
          onClick={this.pressLocal.bind(this)}
        >
          LOCAL TIME
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/toggleButton.js